{{loadFocustelements()}}
<div (keydown)="handleKeydown($event)" class="imei-model-box">
  <div class="imei-modal-header" [style.display]="displayRecords ? 'none' : 'block'">
    <h2 tabindex="0">{{imeiModalData.imeimodalHeader}} </h2>
  </div>
  <div class="imei-modal-header" *ngIf="displayRecords">
    <h2 tabindex="0">{{imeiModalData.imeimodalHeader2}} </h2>
  </div>
  <div class="imei-alert" *ngIf="noRecordsFound">
      <div class="alert valign-children-middle">
        <div class="alert-info" role="img" aria-label="Alert">
          <i class="icon-alert"></i>
        </div>
        <div><span tabindex="0">IMEI entered not found. Check input and retry.</span></div>
      </div>
    </div>
    <div class="imei-alert" *ngIf="systemError">
      <div class="alert valign-children-middle">
        <div class="alert-error" role="img" aria-label="Alert">
          <i class="icon-badgealert"></i>
        </div>
        <div><span tabindex="0">Something isn’t working. We couldn’t perform your search. Please try again.</span></div>
      </div>
    </div>
  <div class="imei-box-outer">
       
    <div class="corner-button">
      <button class="close" aria-label="Close" (click)="btnAction(false)">x</button>
    </div>

    <div class="imei-modal-body box-outer" [style.display]="displayRecords ? 'none' : 'block'">
      <p [innerHtml]="imeiModalData.imeimodalMessage"></p>
      <p class="imei-field-label" >{{imeiModalData.imeiFieldLabel}}</p>
      <input  [ctnmask]=false [formControl]="imeiNumbertoFormate" (rawChange)="imeiNumber=$event" type="text" 
        (keydown)="handleImeiFieldChange()" maxlength="15" placeholder="" class="form-control imei-field" 
        attr.aria-label="{{imeiModalData.imeiFieldLabel}}" aria-describedby="numberError" 
        (keyup.enter)="(imeiNumbertoFormate.value && imeiNumbertoFormate.value.length >= 14) ? imeiNumberLookUp(imeiNumbertoFormate.value) : ''" />
    </div>

    <div class="numberError" id="numberError" *ngIf="validNumberError">Error! Enter a valid IMEI number.</div>   

  </div>
  <div class="text-right imei-modal-footer" [style.display]="displayRecords ? 'none' : 'block'">
    <div class="button-group">
      <button class="btn btn-secondary pull-right" (click)="imeiNumberLookUp(imeiNumbertoFormate.value)" type="submit" 
      [disabled]="(!imeiNumbertoFormate.value || (imeiNumbertoFormate.value && imeiNumbertoFormate.value.length < 14))"  
      attr.aria-label="{{imeiModalData.imeilookupButtonMessage}}">{{imeiModalData.imeilookupButtonMessage}}</button>
      <a href="javascript:void(0)" class="btn btn-link cancel-button-modal" (click)="btnAction(false)" role="button" 
      attr.aria-label="{{imeiModalData.imeicancelButtonMessage}}">{{imeiModalData.imeicancelButtonMessage}}</a>
    </div>
    <div class="clearfix"></div>
  </div>

  <!-- imei list display -->
  <div class="imei-modal-body box-outer" *ngIf="displayRecords">

    <app-custom-grid-extended [gridOptions]='gridOptions' (gridEvent)="gridEventChanges($event)" 
      (onDataChange)="onRowClick($event)"></app-custom-grid-extended>

  </div>



</div>